import { OnboardingACCUserModal } from '@adsk/napi-user-onboarding-form'
export default OnboardingACCUserModal
